import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import classNames from 'classnames'
import gsap from 'gsap'
import { createUseStyles } from 'react-jss'
import usePrevious from '@/hooks/usePrevious'
import style from './style'

const useStyles = createUseStyles(style)

const CartButton = ({
  className,
  link,
  onClick,
  onMouseEnter,
  onMouseLeave,
  tabIndex,
}) => {
  const history = useHistory()
  const classes = useStyles()
  const $counter = useRef(null)
  const [productsQuantity, setProductsQuantity] = useState(0)
  const prevQuantity = usePrevious(productsQuantity)

  useEffect(() => {
    // Ecwid Cart EventListener
    if (window.Ecwid) {
      window.Ecwid.OnCartChanged.add((cart) => {
        setProductsQuantity(cart.productsQuantity)
      })
    }
  }, [])

  useEffect(() => {
    if (prevQuantity < productsQuantity) {
      gsap.killTweensOf($counter.current)
      gsap.fromTo($counter.current, { scale: 1.5 }, {
        scale: 1,
        ease: 'elastic.out(1, 0.5)',
        duration: 1,
      })
    }
  }, [productsQuantity])

  const handleClick = () => {
    if (productsQuantity === 0) {
      history.push(link)
    } else {
      onClick()
    }
  }

  return (
    <button
      aria-label="go-to-checkout"
      className={classNames({
        [className]: className,
        [classes.root]: true,
      })}
      onClick={handleClick}
      tabIndex={tabIndex}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <svg>
        <title>Cart</title>
        <use xlinkHref="#ico-shopping-bag" />
      </svg>
      <span
        className={classNames({
          [classes.counter]: true,
          [classes.visible]: productsQuantity > 0,
        })}
        ref={$counter}
      >
        {productsQuantity}
      </span>
    </button>
  )
}

export default CartButton
